import { render } from "./ExhibitorDetailDialog.vue?vue&type=template&id=4f3122ca&scoped=true&ts=true"
import script from "./ExhibitorDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ExhibitorDetailDialog.vue?vue&type=script&lang=ts"

import "./ExhibitorDetailDialog.vue?vue&type=style&index=0&id=4f3122ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3122ca"]])

export default __exports__